const options = {
  5: "bg-orange-200/5",
  10: "bg-orange-200/10",
  25: "bg-orange-200/25",
  50: "bg-orange-200/50",
  75: "bg-orange-200/75",
  90: "bg-orange-200/90",
  100: "bg-orange-200",
};

const from = {
  5: "from-orange-200/5",
  10: "from-orange-200/10",
  25: "from-orange-200/25",
  50: "from-orange-200/50",
  75: "from-orange-200/75",
  90: "from-orange-200/90",
  100: "from-orange-200",
};

export default function getBackgroundOrange200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
